import { render } from "./orderTrack.vue?vue&type=template&id=4e006a71&scoped=true"
import script from "./orderTrack.vue?vue&type=script&lang=js"
export * from "./orderTrack.vue?vue&type=script&lang=js"

import "./orderTrack.vue?vue&type=style&index=0&id=4e006a71&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e006a71"]])

export default __exports__